<template>
    <ion-page>
        <app-header back="home" title="거래처별출하집계" />
        <ion-content :fullscreen="true">
            <template v-if="isConnected">
                <div id="container">
                    <ion-grid>
                        <ion-row class="ion-justify-content-center">
                            <ion-col size-md="1" size-xs="1.5">
                                <span> 기간</span>
                            </ion-col>
                            <ion-col size-md="2" size-xs="5">
                                <ion-input class="calendar" v-model="frDate" id="frdate" readonly
                                    @click="popChange"><ion-icon :icon="calendar"></ion-icon></ion-input>
                                <ion-popover trigger="frdate" @didDismiss="onWillDismissPopover">
                                    <ion-datetime class="dateitem" id="datetime" display-format="YYYY-MM-DD"
                                        min="2021-01-01" v-model="frDate" presentation="date"
                                        :show-default-buttons="true"></ion-datetime>
                                </ion-popover>
                            </ion-col>
                            <ion-col size-md="1" size-xs="0.5">
                                <span>~</span>
                            </ion-col>
                            <ion-col size-md="2" size-xs="5">
                                <ion-input class="calendar" v-model="toDate" id="todate" readonly
                                    @click="popChange"><ion-icon :icon="calendar"></ion-icon></ion-input>
                                <ion-popover trigger="todate" @didDismiss="onWillDismissPopover">
                                    <ion-datetime class="dateitem" id="datetime" display-format="YYYY-MM-DD"
                                        min="2021-01-01" v-model="toDate" presentation="date"
                                        :show-default-buttons="true"></ion-datetime>
                                </ion-popover>
                            </ion-col>
                            <ion-col size-md="2" size-xs="12">
                                <ion-grid>
                                    <ion-row>
                                        <span style="margin: auto; padding-left: 5px;">영업소</span>
                                        <ion-col>
                                            <ion-label>
                                                <ion-select interface="popover" @ionChange="selectOfficd($event)"
                                                    :value="officecd.code" style="padding-left: 10px;">
                                                    <ion-select-option value="1">전체</ion-select-option>
                                                    <ion-select-option v-for="item in officelist" :key="item.OfficeName"
                                                        :value="item.officeCode">
                                                        {{ item.officeName }}
                                                    </ion-select-option>
                                                </ion-select>
                                            </ion-label>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-col>
                            <ion-col size-md="1" size-xs="6">
                                <ion-button expand="block" class="excel" @click="exportToExcel"
                                    color="success">엑셀변환</ion-button>
                            </ion-col>
                            <ion-col size-md="1" size-xs="6">
                                <ion-button expand="block" @click="listSearch" color="medium">조회</ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                    <p class="ton" style="margin-top: 3px">(단위,톤)</p>
                    <vue-good-table :columns="columns" :rows="accsumlist" :line-numbers="false"
                        :row-style-class="rowStyleFunction" max-height="70vh">
                    </vue-good-table>
                </div>
            </template>
            <template v-else>
                <network-error v-on:@onReConnect="onReConnect" />
            </template>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonCol,
    IonGrid,
    IonRow,
    IonDatetime,
    IonContent,
    IonInput,
    IonButton,
    modalController,
    IonPopover,
    IonIcon,
    onIonViewWillLeave,
    popoverController,
    onIonViewDidEnter,
    IonSelectOption,
    IonSelect,
    IonLabel
} from '@ionic/vue';

import { ref, reactive, defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { toast } from '@/utils/toast';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';
import { setDateFormat } from '@/utils/dateFormatter';
import { accsums } from '@/api/services/accsum';
import { assigns } from '@/api/services/assign';
import { users } from '@/api/services/user';
import * as XLSX from 'xlsx';
import { calendar } from 'ionicons/icons';


export default defineComponent({
    components: {
        IonPage,
        IonIcon,
        IonDatetime,
        IonButton,
        IonCol,
        IonRow,
        IonGrid,
        IonPopover,
        IonContent,
        IonInput,
        VueGoodTable,
        IonSelectOption,
        IonSelect,
        IonLabel
    },
    setup() {
        const form = reactive({
            modalState: false,
            popoverState: false
        });
        async function onWillDismiss() {
            form.modalState = false;
        }
        async function onWillDismissPopover() {
            form.popoverState = false;
        }
        async function modalChange() {
            form.modalState = true;
        }
        async function popChange() {
            form.popoverState = true;
        }
        const store = useStore();
        const auth = computed(() => store.getters['auth/getData']);
        const { saveLog } = users();

        const { isConnected, fetchDatas, accsumlist } = accsums();
        const { officelist, fetchOfficeDatas } = assigns();

        const now = (new Date());
        const frDate = ref(setDateFormat(new Date(now.getFullYear(), now.getMonth(), 1), 'YYYY-MM-DD')); //ref('2023-01-01');
        const toDate = ref(setDateFormat(new Date(), 'YYYY-MM-DD'));
        const salenm = reactive({
            title: '',
        });

        const officecd = reactive({
            code: '1',
        });

        onIonViewDidEnter(async () => {
            fetchOfficeDatas()
            saveLog(auth.value.id, '거래처별출하집계');
        });

        function selectOfficd(e) {
            officecd.code = e.target.value;
        }

        async function listSearch() {
            await fetchDatas(frDate.value.substring(0, 10).replaceAll('-', ''), toDate.value.substring(0, 10).replaceAll('-', ''), officecd.code, auth.value.id);
        }
        function customd01(row) {
            if (row.saleQunt) return row.saleQunt.toLocaleString('ko-KR', { minimumFractionDigits: 2 });

        }

        function customdc(row) {
            if (row.saleQunt) return 'currency';
        }
        const columns = reactive([
        {
                label: '청구처',
                field: 'saleName',
                width: '120px',
                sortable: false,
                //thClass: 'txtcolor'
            },
            {
                label: '착지',
                field: 'dplaceName',
                width: '120px',
                sortable: false,
                //tdClass: customd03
            },
            {
                label: '품목',
                field: 'itnm',
                width: '100px',
                sortable: false,
                //tdClass: customd04
            },
            {
                label: '출하일자',
                field: 'saDateNm',
                width: '100px',
                sortable: false,
                //tdClass: customd02
            },
            {
                label: '출하량',
                field: customd01,
                width: '80px',
                sortable: false,
                tdClass: customdc
            }

        ]);

        
        onIonViewWillLeave(async () => {
            if (form.popoverState == true) {
                await popoverController.dismiss()
            }
        });
        const exportToExcel = () => {
            const data = Object.values(accsumlist.value).map(row => [row.saleName, row.dplaceName, row.itnmname_s, row.saDateNm, row.saleQunt]);
            data.unshift(columns.map(col => col.label));
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, "거래처별출하집계.xlsx");
        }

        function rowStyleFunction(row) {
            if (row.saDateNm) {
                if (row.saDateNm.includes('소계')) {
                    return 'row-subtotal-color';
                } else if (row.saDateNm.includes('합계')) {
                    return 'row-total-color';
                } else if (row.saDateNm.includes('총계')) {
                    return 'row-all-total-color'
                }
            }
        }

        return {
            isConnected,
            frDate,
            toDate,
            listSearch,
            accsumlist,
            columns,
            salenm,
            exportToExcel,
            calendar,
            auth,
            form,
            modalChange,
            onWillDismiss,
            onWillDismissPopover,
            popChange,
            rowStyleFunction,
            selectOfficd,
            officelist,
            officecd
        };
    }

});

</script>

<style scoped>
#container {
    padding-left: 0.5em;
    padding-right: 0.5em;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
}

.ton {
    text-align: right;
    font-size: 13px;
}

ion-item {
    text-align: center;
    height: 40px;

}

ion-grid {
    padding: 0;

}

ion-col {
    padding: 0;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;

}

ion-modal#example-modal {
    --width: fit-content;
    --min-width: 250px;
    --height: fit-content;
    --border-radius: 6px;
    --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

ion-col .calendar {
    padding: 0;
}
</style>